import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { CONTEXT_HEADER, ErrorResponseType, toErrorResponse } from './api-errors';
import { ApiService } from './api.service';

/**
 * Define `Accept`, `Content-Type` e `Accept-Language: pt-BR` em todas as requisições e
 * normaliza os erros HTTP em `ErrorResponse` (com o `context` do header `Context`).
 * Erros BadRequest (4xx de validação) são notificados ao `ApiService.onBadRequest(context)`.
 */
export const apiInterceptor: HttpInterceptorFn = (req, next) => {
  const apiService = inject(ApiService);
  const request = req.clone({
    setHeaders: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'Accept-Language': 'pt-BR',
    },
  });

  return next(request).pipe(
    catchError((error: unknown) => {
      if (!(error instanceof HttpErrorResponse)) {
        return throwError(() => error);
      }
      const errorResponse = toErrorResponse(error, request.headers.get(CONTEXT_HEADER));
      if (errorResponse.type === ErrorResponseType.BadRequest) {
        apiService.notifyBadRequest(errorResponse);
      }
      return throwError(() => errorResponse);
    }),
  );
};
